import * as THREE from "three";

export default function(size, camera, textureLoader) {
  Object.setPrototypeOf(this, new THREE.Object3D());
  this.name = "Background";

  const texture1 = textureLoader.load("/img/3DTextures/xterminate/game/background1.jpg");
  texture1.repeat.set(0.9, 0.9);
  texture1.offset.set(0.1, 0.1);
  const texture2 = textureLoader.load("/img/3DTextures/xterminate/game/background2.jpg");
  texture2.repeat.set(0.9, 0.9);
  texture2.offset.set(0.1, 0.1);
  const texture3 = textureLoader.load("/img/3DTextures/xterminate/game/background3.jpg");
  texture3.repeat.set(0.9, 0.9);
  texture3.offset.set(0.1, 0.1);
  const texture4 = textureLoader.load("/img/3DTextures/xterminate/game/background4.jpg");
  texture4.repeat.set(0.9, 0.9);
  texture4.offset.set(0.1, 0.1);
  const texture5 = textureLoader.load("/img/3DTextures/xterminate/game/background5.jpg");
  texture5.repeat.set(0.9, 0.9);
  texture5.offset.set(0.1, 0.1);
  const texture6 = textureLoader.load("/img/3DTextures/xterminate/game/background6.jpg");
  texture6.repeat.set(0.9, 0.9);
  texture6.offset.set(0.1, 0.1);

  const geometry = new THREE.BoxBufferGeometry(size, size, size);
  const material = [
    new THREE.MeshBasicMaterial({ map: texture1 }),
    new THREE.MeshBasicMaterial({ map: texture2 }),
    new THREE.MeshBasicMaterial({ map: texture3 }),
    new THREE.MeshBasicMaterial({ map: texture4 }),
    new THREE.MeshBasicMaterial({ map: texture5 }),
    new THREE.MeshBasicMaterial({ map: texture6 })
  ];

  const mesh = new THREE.Mesh(geometry, material);
  mesh.geometry.scale(1, 1, -1);

  this.add(mesh);

  /*
   * @function - perform
   * Action of agents oriented programming 3d interfaces
   * @param - scene (ThreeJS Scene Instance): Scene instance of the 3d scene
   */
  function perform() {
    if (Math.abs(camera.position.x) + Math.abs(camera.position.z) < 20) {
      camera.position.x < 0 ? (this.rotation.x -= 0.005) : (this.rotation.x += 0.005);

      camera.position.y < 2 ? (this.rotation.y -= 0.005) : (this.rotation.y += 0.005);

      camera.position.z < 0 ? (this.rotation.z -= 0.005) : (this.rotation.z += 0.005);
    }
  }

  this.perform = perform;
}
